import React, { useEffect, useState, useMemo } from 'react';
import { Spinner } from 'reactstrap';
import { getDashboardByEstablishmentType } from '../../../../helpers/water_rights/backend_helper';
import EChartsDoughnutChart from '../../../../Components/Common/Charts/ECharts/EChartsDoughnutChart';
import { generateColorGradient } from '../../../../Components/Hooks/useColorArrayHooks';

const WaterRightsByEstablishmentChart = () => {
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let cancelled = false;
		getDashboardByEstablishmentType()
			.then(res => { if (!cancelled) setData(Array.isArray(res) ? res : []); })
			.catch(() => {})
			.finally(() => { if (!cancelled) setIsLoading(false); });
		return () => { cancelled = true; };
	}, []);

	const options = useMemo(() => ({
		tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
		legend: { top: '5%', left: 'center' },
		color: generateColorGradient(data.length || 1),
		series: [{
			name: 'Por Establecimiento',
			type: 'pie',
			radius: ['40%', '70%'],
			avoidLabelOverlap: false,
			itemStyle: { borderRadius: 10, borderColor: '#fff', borderWidth: 2 },
			label: { show: false, position: 'center' },
			emphasis: { label: { show: false, fontSize: 14, fontWeight: 'bold' } },
			labelLine: { show: false },
			data: data.map(d => ({ value: d.count, name: d.establishment_type || 'Sin Tipo' })),
		}],
	}), [data]);

	if (isLoading) {
		return <div className='d-flex justify-content-center align-items-center py-4'><Spinner size='sm' /></div>;
	}

	if (!data.length) {
		return <div className='d-flex flex-column align-items-center justify-content-center text-muted py-4 h-100'><p className='mb-0'>Sin datos disponibles</p></div>;
	}

	return <EChartsDoughnutChart options={options} />;
};

export default WaterRightsByEstablishmentChart;
